// extracted by mini-css-extract-plugin
module.exports = {"container":"_5a28450529--container--lqbXR","banner":"_5a28450529--banner--socSW","wrapper":"_5a28450529--wrapper--ZHbu5","title":"_5a28450529--title--RChCF"};